class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.customCartCountdownInterval = null;

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));

this.addEventListener(
  'change',
  (event) => {
    const target = event.target;

    if (!target.matches('[data-custom-cart-variant-option]')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    this.handleVariantChange(target);
  },
  true
);

this.setHeaderCartIconAccessibility();
this.initFloatingCartButton();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
  this.classList.add('animate', 'active');
  this.startPromoCountdown();
});

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    this.lockBodyScroll();

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its `view-event-trigger="manual"` skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with `context: 'dialog'` from the payload attribute.
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    this.unlockBodyScroll();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
initFloatingCartButton() {
  const floatingButton = document.querySelector('[data-custom-cart-floating-button]');
  if (!floatingButton) return;
  if (floatingButton.dataset.floatingCartInitialized === 'true') return;

  floatingButton.dataset.floatingCartInitialized = 'true';

  const getProductSubmitButton = () => {
    const productForm =
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    return (
      productForm?.querySelector('[type="submit"]') ||
      document.querySelector('button[name="add"]')
    );
  };

  const hideFloatingButton = () => {
    floatingButton.classList.remove('is-visible');
  };

  const updateFloatingButton = () => {
    if (window.innerWidth > 749) {
      hideFloatingButton();
      return;
    }

    if (document.body.classList.contains('cart-drawer-open')) {
      hideFloatingButton();
      return;
    }

    const submitButton = getProductSubmitButton();

    if (!submitButton) {
      hideFloatingButton();
      return;
    }

    const buttonPosition = submitButton.getBoundingClientRect();

    // Só mostra quando o botão original já saiu da tela para cima
    const originalButtonDisappearedAbove = buttonPosition.bottom <= 0;

    if (originalButtonDisappearedAbove) {
      floatingButton.classList.add('is-visible');
    } else {
      hideFloatingButton();
    }
  };

  floatingButton.addEventListener('click', () => {
    const submitButton = getProductSubmitButton();

    if (submitButton && !submitButton.disabled) {
      submitButton.click();
      return;
    }

    this.open(floatingButton);
  });

  window.addEventListener('scroll', updateFloatingButton, { passive: true });
  window.addEventListener('resize', updateFloatingButton);

  updateFloatingButton();
}

getSelectedVariant(selectorGroup) {
  const variantsScript = selectorGroup.querySelector('[data-product-variants-json]');
  const selects = selectorGroup.querySelectorAll('[data-custom-cart-variant-option]');

  if (!variantsScript || !selects.length) return null;

  let variants = [];

  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (error) {
    console.error('Erro ao ler variantes:', error);
    return null;
  }

  const selectedOptions = Array.from(selects).map((select) => select.value);

  return variants.find((variant) => {
    return selectedOptions.every((value, index) => variant.options[index] === value);
  });
}

getCartAddUrl() {
  if (typeof routes !== 'undefined' && routes.cart_add_url) {
    return routes.cart_add_url;
  }

  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  return `${root}cart/add.js`;
}

getCartChangeUrl() {
  if (typeof routes !== 'undefined' && routes.cart_change_url) {
    return routes.cart_change_url;
  }

  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  return `${root}cart/change.js`;
}

async handleVariantChange(select) {
  const selectorGroup = select.closest('[data-custom-cart-variant-selectors]');
  if (!selectorGroup) return;

  const newVariant = this.getSelectedVariant(selectorGroup);
  const currentVariantId = Number(selectorGroup.dataset.currentVariantId);
  const oldLineKey = selectorGroup.dataset.lineKey;
  const oldLineIndex = Number(selectorGroup.dataset.lineIndex);
  const quantity = Number(selectorGroup.dataset.quantity || 1);

  if (!newVariant) {
    alert('Essa combinação não existe.');
    return;
  }

  if (!newVariant.available) {
    alert('Essa variação está esgotada.');
    return;
  }

  if (Number(newVariant.id) === currentVariantId) return;

  await this.replaceCartVariant({
    newVariantId: newVariant.id,
    oldVariantId: currentVariantId,
    oldLineKey,
    oldLineIndex,
    quantity,
    selectorGroup,
  });
}

async replaceCartVariant({ newVariantId, oldVariantId, oldLineKey, oldLineIndex, quantity, selectorGroup }) {
  const selects = selectorGroup.querySelectorAll('[data-custom-cart-variant-option]');
  const sections = this.getSectionsToRender().map((section) => section.id);

  selects.forEach((select) => {
    select.disabled = true;
  });

  try {
    const removeBody = Number.isFinite(oldLineIndex) && oldLineIndex > 0
      ? {
          line: oldLineIndex,
          quantity: 0,
        }
      : {
          id: oldLineKey,
          quantity: 0,
        };

    const removeResponse = await fetch(this.getCartChangeUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(removeBody),
    });

    const removeState = await removeResponse.json();

    if (!removeResponse.ok || removeState.status) {
      throw new Error(removeState.description || removeState.message || 'Não foi possível remover a variação anterior.');
    }

    const addResponse = await fetch(this.getCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: Number(newVariantId),
        quantity: Math.max(1, quantity),
        sections,
        sections_url: window.location.pathname,
      }),
    });

    const updatedState = await addResponse.json();

    if (!addResponse.ok || updatedState.status) {
      await fetch(this.getCartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: Number(oldVariantId),
          quantity: Math.max(1, quantity),
        }),
      });

      throw new Error(updatedState.description || updatedState.message || 'Não foi possível adicionar a nova variação.');
    }

    this.renderContents(updatedState);
  } catch (error) {
    console.error(error);
    alert(error.message || 'Não foi possível trocar a variação.');

    selects.forEach((select) => {
      select.disabled = false;
    });
  }
}

lockBodyScroll() {
  if (document.body.classList.contains('cart-drawer-scroll-locked')) return;

  const scrollY = window.scrollY || window.pageYOffset || 0;

  document.body.dataset.cartDrawerScrollY = String(scrollY);
  document.body.classList.add('overflow-hidden', 'cart-drawer-open', 'cart-drawer-scroll-locked');

  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
}

unlockBodyScroll() {
  const scrollY = Number(document.body.dataset.cartDrawerScrollY || 0);

  document.body.classList.remove('overflow-hidden', 'cart-drawer-open', 'cart-drawer-scroll-locked');

  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';

  delete document.body.dataset.cartDrawerScrollY;

  window.scrollTo(0, scrollY);
}
startPromoCountdown() {
  const timerElement = this.querySelector('[data-custom-cart-countdown]');
  const promoBar = this.querySelector('.custom-cart-promo-bar');

  if (this.customCartCountdownInterval) {
    clearInterval(this.customCartCountdownInterval);
    this.customCartCountdownInterval = null;
  }

  if (!timerElement || !promoBar) return;
  if (promoBar.dataset.customCartTimerEnabled !== 'true') return;

  const minutes = Number(promoBar.dataset.customCartTimerMinutes || 10);
  const endTime = Date.now() + Math.max(1, minutes) * 60 * 1000;

  const updateTimer = () => {
    const remainingSeconds = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
    const displayMinutes = Math.floor(remainingSeconds / 60);
    const displaySeconds = remainingSeconds % 60;

    timerElement.textContent = `${String(displayMinutes).padStart(2, '0')}:${String(displaySeconds).padStart(2, '0')}`;

    if (remainingSeconds <= 0 && this.customCartCountdownInterval) {
      clearInterval(this.customCartCountdownInterval);
      this.customCartCountdownInterval = null;
    }
  };

  updateTimer();
  this.customCartCountdownInterval = setInterval(updateTimer, 1000);
}
  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
(function () {
  function getUpsellCards(section) {
    return Array.from(section.querySelectorAll('[data-custom-cart-upsell-card]'));
  }

  function updateUpsellArrows(section) {
  if (!section) return;

  const viewport = section.querySelector('[data-custom-cart-upsell-viewport]');
  const prevButton = section.querySelector('[data-custom-cart-upsell-prev]');
  const nextButton = section.querySelector('[data-custom-cart-upsell-next]');
  const cards = getUpsellCards(section);
  const isCarousel = section.classList.contains('custom-cart-upsells--carousel');

  if (!viewport || !prevButton || !nextButton) return;

  if (!isCarousel || cards.length <= 1) {
    prevButton.hidden = true;
    nextButton.hidden = true;
    return;
  }

  prevButton.hidden = false;
  nextButton.hidden = false;

  prevButton.disabled = false;
  nextButton.disabled = false;
}

  function initUpsellSection(section) {
    if (!section) return;

    const viewport = section.querySelector('[data-custom-cart-upsell-viewport]');
    if (!viewport) return;

    updateUpsellArrows(section);

    if (viewport.dataset.customCartUpsellScrollBound === 'true') return;

    viewport.dataset.customCartUpsellScrollBound = 'true';

    let ticking = false;

    viewport.addEventListener(
      'scroll',
      () => {
        if (ticking) return;

        ticking = true;

        requestAnimationFrame(() => {
          updateUpsellArrows(section);
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  function initAllUpsellSections() {
    document.querySelectorAll('[data-custom-cart-upsells]').forEach(initUpsellSection);
  }

  function moveUpsellCarousel(button, direction) {
  const section = button.closest('[data-custom-cart-upsells]');
  if (!section) return;

  const viewport = section.querySelector('[data-custom-cart-upsell-viewport]');
  const cards = getUpsellCards(section);

  if (!viewport || cards.length <= 1) return;

  const slideWidth = viewport.clientWidth;
  const currentIndex = Math.round(viewport.scrollLeft / slideWidth);
  const lastIndex = cards.length - 1;

  let nextIndex = currentIndex + direction;

  if (nextIndex < 0) {
    nextIndex = lastIndex;
  }

  if (nextIndex > lastIndex) {
    nextIndex = 0;
  }

  viewport.scrollTo({
    left: nextIndex * slideWidth,
    behavior: 'smooth',
  });

  setTimeout(() => updateUpsellArrows(section), 350);
}

  document.addEventListener('click', (event) => {
    const prevButton = event.target.closest('[data-custom-cart-upsell-prev]');
    const nextButton = event.target.closest('[data-custom-cart-upsell-next]');

    if (prevButton) {
      event.preventDefault();
      moveUpsellCarousel(prevButton, -1);
      return;
    }

    if (nextButton) {
      event.preventDefault();
      moveUpsellCarousel(nextButton, 1);
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-custom-cart-upsell-variant-select]');
    if (!select) return;

    const card = select.closest('[data-custom-cart-upsell-card]');
    if (!card) return;

    const button = card.querySelector('[data-custom-cart-order-bump-add]');
    if (!button) return;

    button.dataset.variantId = select.value;
  });

  document.addEventListener('DOMContentLoaded', initAllUpsellSections);
  document.addEventListener('shopify:section:load', initAllUpsellSections);
  document.addEventListener('shopify:section:select', initAllUpsellSections);
  document.addEventListener('shopify:block:select', initAllUpsellSections);

  const observer = new MutationObserver(() => {
    clearTimeout(window.customCartUpsellObserverTimeout);

    window.customCartUpsellObserverTimeout = setTimeout(() => {
      initAllUpsellSections();
    }, 80);
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  window.CustomCartUpsells = {
    init: initAllUpsellSections,
  };
})();
(function () {
  function getShopifyRoute(path) {
    const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return `${root}${path}`;
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getSectionsToRender(cartDrawer) {
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map((section) => section.id);
    }

    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function getSelectedUpsellVariantId(button) {
  const card = button.closest('[data-custom-cart-upsell-card]');

  if (!card) {
    return Number(button.dataset.variantId);
  }

  const optionSelects = card.querySelectorAll(
    '[data-custom-cart-upsell-option-select]'
  );

  if (!optionSelects.length) {
    const singleSelect = card.querySelector(
      '[data-custom-cart-upsell-variant-select]'
    );

    return singleSelect
      ? Number(singleSelect.value)
      : Number(button.dataset.variantId);
  }

  const variantsScript = card.querySelector(
    '[data-upsell-variants-json]'
  );

  if (!variantsScript) {
    return Number(button.dataset.variantId);
  }

  let variants = [];

  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (error) {
    console.error('Erro ao carregar variantes do upsell:', error);
    return Number(button.dataset.variantId);
  }

  const selectedOptions = Array.from(optionSelects)
    .sort(
      (a, b) =>
        Number(a.dataset.optionIndex) -
        Number(b.dataset.optionIndex)
    )
    .map((select) => select.value);

  const matchedVariant = variants.find((variant) => {
    return selectedOptions.every(
      (selectedValue, optionIndex) =>
        variant.options[optionIndex] === selectedValue
    );
  });

  if (!matchedVariant) {
    return 0;
  }

  return Number(matchedVariant.id);
}

  async function addUpsellToCart(button) {
    if (!button || button.disabled) return;

    const variantId = getSelectedUpsellVariantId(button);

    if (!variantId) {
      alert('Selecione uma opção válida.');
      return;
    }

    const originalText = button.textContent.trim();
    const cartDrawer = getCartDrawer();
    const sections = getSectionsToRender(cartDrawer);

    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const response = await fetch(getShopifyRoute('cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections,
          sections_url: window.location.pathname,
        }),
      });

      const parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        throw new Error(parsedState.description || parsedState.message || 'Não foi possível adicionar a oferta.');
      }

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
      } else {
        window.location.reload();
      }

      setTimeout(() => {
        const updatedCartDrawer = getCartDrawer();

        if (updatedCartDrawer && typeof updatedCartDrawer.startPromoCountdown === 'function') {
          updatedCartDrawer.startPromoCountdown();
        }

        if (window.CustomCartUpsells && typeof window.CustomCartUpsells.init === 'function') {
          window.CustomCartUpsells.init();
        }
      }, 400);
    } catch (error) {
      console.error(error);

      alert(error.message || 'Não foi possível adicionar a oferta.');

      button.disabled = false;
      button.textContent = originalText;
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-custom-cart-order-bump-add]');

      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      addUpsellToCart(button);
    },
    true
  );

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-custom-cart-upsell-variant-select]');

    if (!select) return;

    const card = select.closest('[data-custom-cart-upsell-card]');
    const button = card ? card.querySelector('[data-custom-cart-order-bump-add]') : null;

    if (!button) return;

    button.dataset.variantId = select.value;
  });
})();
(function () {
  document.addEventListener(
    'change',
    (event) => {
      const select = event.target.closest('[data-custom-cart-upsell-variant-select]');

      if (!select) return;

      event.stopPropagation();

      const card = select.closest('[data-custom-cart-upsell-card]');
      const button = card ? card.querySelector('[data-custom-cart-order-bump-add]') : null;

      if (!button) return;

      button.dataset.variantId = select.value;
    },
    true
  );
})();
/* ATUALIZA VISUAL DA VARIANTE DO UPSELL */
(function () {
  function updateUpsellVariantVisual(select) {
    if (!select) return;

    const card = select.closest('[data-custom-cart-upsell-card]');
    if (!card) return;

    const selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;

    const button = card.querySelector('[data-custom-cart-order-bump-add]');
    const image = card.querySelector('.custom-cart-upsell-card__image');
    const priceWrapper = card.querySelector('.custom-cart-upsell-card__price');
    const priceStrong = priceWrapper ? priceWrapper.querySelector('strong') : null;
    const comparePrice = priceWrapper ? priceWrapper.querySelector('s') : null;

    if (button) {
      button.dataset.variantId = selectedOption.value;
    }

    if (image && selectedOption.dataset.image) {
      image.src = selectedOption.dataset.image;
    }

    if (priceStrong && selectedOption.dataset.price) {
      priceStrong.textContent = selectedOption.dataset.price;
    }

    if (comparePrice) {
      if (selectedOption.dataset.comparePrice) {
        comparePrice.textContent = selectedOption.dataset.comparePrice;
        comparePrice.style.display = '';
      } else {
        comparePrice.textContent = '';
        comparePrice.style.display = 'none';
      }
    }
  }

  document.addEventListener(
    'change',
    (event) => {
      const select = event.target.closest('[data-custom-cart-upsell-variant-select]');
      if (!select) return;

      event.stopPropagation();
      event.stopImmediatePropagation();

      updateUpsellVariantVisual(select);
    },
    true
  );

  document.addEventListener(
    'input',
    (event) => {
      const select = event.target.closest('[data-custom-cart-upsell-variant-select]');
      if (!select) return;

      updateUpsellVariantVisual(select);
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-custom-cart-upsell-variant-select]').forEach(updateUpsellVariantVisual);
  });

  window.CustomCartUpdateUpsellVariants = function () {
    document.querySelectorAll('[data-custom-cart-upsell-variant-select]').forEach(updateUpsellVariantVisual);
  };
})();
/* ===== PERSISTE AS OPÇÕES INDEPENDENTES DOS UPSELLS ===== */
(function () {
  const CARD_SELECTOR =
    '[data-custom-cart-upsell-card]';

  const OPTION_SELECTOR =
    '[data-custom-cart-upsell-option-select]';

  const STORAGE_PREFIX =
    'ht_cart_upsell_options_';

  let restoreTimeout = null;

  function getCardKey(card) {
    if (!card) return '';

    const originalKey =
      card.dataset.customCartUpsellKey || '';

    /*
     * O Liquid gera chaves como:
     * upsell-1-123456789
     * upsell-2-123456789
     *
     * Removemos o número da posição para a escolha
     * continuar funcionando mesmo se o produto mudar
     * de posição dentro dos upsells.
     */
    if (originalKey) {
      return originalKey.replace(
        /^upsell-\d+-/,
        'product-'
      );
    }

    const cards = Array.from(
      document.querySelectorAll(CARD_SELECTOR)
    );

    return `card-${cards.indexOf(card)}`;
  }

  function getStorageKey(card) {
    const cardKey = getCardKey(card);

    return `${STORAGE_PREFIX}${cardKey}`;
  }

  function getOptionSelects(card) {
    return Array.from(
      card.querySelectorAll(OPTION_SELECTOR)
    ).sort((firstSelect, secondSelect) => {
      return (
        Number(firstSelect.dataset.optionIndex) -
        Number(secondSelect.dataset.optionIndex)
      );
    });
  }

  function getSelectKey(select, fallbackIndex) {
    if (select.dataset.optionIndex !== undefined) {
      return `option-${select.dataset.optionIndex}`;
    }

    if (select.dataset.optionName) {
      return `name-${select.dataset.optionName}`;
    }

    return `option-${fallbackIndex}`;
  }

  function saveCardSelections(card) {
    if (!card) return;

    const selects = getOptionSelects(card);

    if (!selects.length) return;

    const selections = {};

    selects.forEach((select, index) => {
      const selectKey = getSelectKey(
        select,
        index
      );

      selections[selectKey] = select.value;
    });

    try {
      sessionStorage.setItem(
        getStorageKey(card),
        JSON.stringify(selections)
      );
    } catch (error) {
      console.warn(
        'Não foi possível salvar as opções do upsell:',
        error
      );
    }
  }

  function getSavedSelections(card) {
    try {
      const storedValue = sessionStorage.getItem(
        getStorageKey(card)
      );

      if (!storedValue) return null;

      const parsedValue = JSON.parse(storedValue);

      if (
        !parsedValue ||
        typeof parsedValue !== 'object'
      ) {
        return null;
      }

      return parsedValue;
    } catch (error) {
      console.warn(
        'Não foi possível recuperar as opções do upsell:',
        error
      );

      return null;
    }
  }

  function getVariants(card) {
    const variantsScript = card.querySelector(
      '[data-upsell-variants-json]'
    );

    if (!variantsScript) return [];

    try {
      return JSON.parse(
        variantsScript.textContent || '[]'
      );
    } catch (error) {
      console.error(
        'Não foi possível ler as variantes do upsell:',
        error
      );

      return [];
    }
  }

  function getSelectedValues(card) {
    return getOptionSelects(card).map(
      (select) => select.value
    );
  }

  function findSelectedVariant(card) {
    const variants = getVariants(card);
    const selectedValues =
      getSelectedValues(card);

    if (!variants.length) return null;

    return (
      variants.find((variant) => {
        if (!Array.isArray(variant.options)) {
          return false;
        }

        return selectedValues.every(
          (selectedValue, optionIndex) => {
            return (
              variant.options[optionIndex] ===
              selectedValue
            );
          }
        );
      }) || null
    );
  }

  function syncCardVariant(card) {
    if (!card) return;

    const selectedVariant =
      findSelectedVariant(card);

    const button = card.querySelector(
      '[data-custom-cart-order-bump-add]'
    );

    if (button && selectedVariant) {
      button.dataset.variantId =
        selectedVariant.id;
    }
  }

  function refreshUpsellVisuals() {
    if (
      typeof window
        .CustomCartUpdateUpsellImages ===
      'function'
    ) {
      window.CustomCartUpdateUpsellImages();
    }
  }

  function restoreCardSelections(card) {
    if (!card) return;

    const savedSelections =
      getSavedSelections(card);

    if (!savedSelections) return;

    const selects = getOptionSelects(card);

    selects.forEach((select, index) => {
      const selectKey = getSelectKey(
        select,
        index
      );

      const savedValue =
        savedSelections[selectKey];

      if (savedValue === undefined) return;

      const validOption = Array.from(
        select.options
      ).find((option) => {
        return (
          option.value === savedValue &&
          !option.disabled
        );
      });

      if (validOption) {
        select.value = savedValue;
      }
    });

    /*
     * Depois de devolver cor e tamanho,
     * sincroniza o ID real da variante.
     */
    syncCardVariant(card);
  }

  function restoreAllSelections() {
    document
      .querySelectorAll(CARD_SELECTOR)
      .forEach(restoreCardSelections);

    /*
     * Atualiza a imagem depois que as escolhas
     * foram devolvidas aos selects.
     */
    refreshUpsellVisuals();
  }

  function scheduleRestore() {
    clearTimeout(restoreTimeout);

    restoreTimeout = setTimeout(() => {
      restoreAllSelections();

      /*
       * Segunda tentativa porque o drawer pode
       * terminar de renderizar alguns milissegundos
       * depois da primeira atualização.
       */
      setTimeout(
        restoreAllSelections,
        150
      );
    }, 60);
  }

  document.addEventListener(
    'change',
    (event) => {
      const select = event.target.closest(
        OPTION_SELECTOR
      );

      if (!select) return;

      const card = select.closest(
        CARD_SELECTOR
      );

      saveCardSelections(card);
      syncCardVariant(card);
    },
    true
  );

  document.addEventListener(
    'input',
    (event) => {
      const select = event.target.closest(
        OPTION_SELECTOR
      );

      if (!select) return;

      const card = select.closest(
        CARD_SELECTOR
      );

      saveCardSelections(card);
      syncCardVariant(card);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleRestore
    );
  } else {
    scheduleRestore();
  }

  document.addEventListener(
    'shopify:section:load',
    scheduleRestore
  );

  document.addEventListener(
    'shopify:section:select',
    scheduleRestore
  );

  document.addEventListener(
    'shopify:block:select',
    scheduleRestore
  );

  /*
   * Detecta quando a Shopify troca o HTML
   * do carrinho depois da alteração do produto
   * principal, quantidade ou variante.
   */
  const observer = new MutationObserver(() => {
    scheduleRestore();
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  window.HTCartRestoreUpsellOptions =
    restoreAllSelections;
})();
/* ===== UPSELL: ATUALIZA IMAGEM PELA COR SELECIONADA ===== */
(function () {
  const CARD_SELECTOR = '[data-custom-cart-upsell-card]';
  const OPTION_SELECTOR = '[data-custom-cart-upsell-option-select]';

  function getUpsellVariants(card) {
    const variantsScript = card.querySelector(
      '[data-upsell-variants-json]'
    );

    if (!variantsScript) return [];

    try {
      return JSON.parse(variantsScript.textContent || '[]');
    } catch (error) {
      console.error(
        'Não foi possível carregar as variantes do upsell:',
        error
      );

      return [];
    }
  }

  function getOptionSelects(card) {
    return Array.from(
      card.querySelectorAll(OPTION_SELECTOR)
    ).sort((firstSelect, secondSelect) => {
      return (
        Number(firstSelect.dataset.optionIndex) -
        Number(secondSelect.dataset.optionIndex)
      );
    });
  }

  function getSelectedOptions(card) {
    return getOptionSelects(card).map((select) => select.value);
  }

  function findSelectedVariant(card, variants) {
    const selectedOptions = getSelectedOptions(card);

    return variants.find((variant) => {
      if (!Array.isArray(variant.options)) return false;

      return selectedOptions.every((selectedValue, optionIndex) => {
        return variant.options[optionIndex] === selectedValue;
      });
    });
  }

  function normalizeOptionName(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(':', '')
      .trim()
      .toLowerCase();
  }

  function isColorSelect(select) {
    const label = select
      .closest('.custom-cart-upsell-card__option-field')
      ?.querySelector('.custom-cart-upsell-card__variant-label');

    const optionName = normalizeOptionName(
      select.dataset.optionName || label?.textContent
    );

    return (
      optionName === 'color' ||
      optionName === 'colour' ||
      optionName === 'cor'
    );
  }

  function getVariantImageUrl(variant) {
    if (!variant) return '';

    if (
      variant.featured_image &&
      typeof variant.featured_image === 'string'
    ) {
      return variant.featured_image;
    }

    if (variant.featured_image?.src) {
      return variant.featured_image.src;
    }

    if (variant.featured_media?.preview_image?.src) {
      return variant.featured_media.preview_image.src;
    }

    if (variant.image?.src) {
      return variant.image.src;
    }

    if (typeof variant.image === 'string') {
      return variant.image;
    }

    return '';
  }

  function findVariantImage(
    card,
    variants,
    selectedVariant
  ) {
    /*
     * Primeiro tenta usar a imagem da combinação exata:
     * cor + tamanho.
     */
    const selectedVariantImage =
      getVariantImageUrl(selectedVariant);

    if (selectedVariantImage) {
      return selectedVariantImage;
    }

    /*
     * Caso a variante exata não tenha imagem própria,
     * procura outra variante da mesma cor que tenha imagem.
     */
    const selects = getOptionSelects(card);
    const colorSelect = selects.find(isColorSelect);

    if (!colorSelect) return '';

    const colorIndex = Number(
      colorSelect.dataset.optionIndex
    );

    const selectedColor = colorSelect.value;

    const variantWithSameColor = variants.find((variant) => {
      return (
        Array.isArray(variant.options) &&
        variant.options[colorIndex] === selectedColor &&
        getVariantImageUrl(variant)
      );
    });

    return getVariantImageUrl(variantWithSameColor);
  }

  function updateUpsellCardImage(card) {
    if (!card) return;

    const variants = getUpsellVariants(card);

    if (!variants.length) return;

    const selectedVariant = findSelectedVariant(
      card,
      variants
    );

    /*
     * Mantém também o ID do botão sincronizado
     * com a combinação selecionada.
     */
    if (selectedVariant) {
      const button = card.querySelector(
        '[data-custom-cart-order-bump-add]'
      );

      if (button) {
        button.dataset.variantId = selectedVariant.id;
      }
    }

    const imageUrl = findVariantImage(
      card,
      variants,
      selectedVariant
    );

    if (!imageUrl) return;

    const image = card.querySelector(
      '.custom-cart-upsell-card__image'
    );

    if (!image) return;

    image.src = imageUrl;
    image.srcset = '';

    const colorSelect = getOptionSelects(card).find(
      isColorSelect
    );

    if (colorSelect) {
      image.alt = colorSelect.value;
    }
  }

  function updateAllUpsellCardImages() {
    document
      .querySelectorAll(CARD_SELECTOR)
      .forEach(updateUpsellCardImage);
  }

  /*
   * Listener delegado:
   * continua funcionando depois que o drawer é atualizado.
   */
  document.addEventListener(
    'change',
    (event) => {
      const select = event.target.closest(
        OPTION_SELECTOR
      );

      if (!select) return;

      const card = select.closest(CARD_SELECTOR);

      updateUpsellCardImage(card);
    },
    true
  );

  document.addEventListener(
    'input',
    (event) => {
      const select = event.target.closest(
        OPTION_SELECTOR
      );

      if (!select) return;

      const card = select.closest(CARD_SELECTOR);

      updateUpsellCardImage(card);
    },
    true
  );

  /*
   * Atualiza os cards que já existem quando a página abre.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateAllUpsellCardImages
    );
  } else {
    updateAllUpsellCardImages();
  }

  document.addEventListener(
    'shopify:section:load',
    updateAllUpsellCardImages
  );

  /*
   * O carrinho substitui o HTML quando é atualizado.
   * Este observer inicializa novamente as imagens.
   */
  let updateTimeout = null;

  const observer = new MutationObserver(() => {
    clearTimeout(updateTimeout);

    updateTimeout = setTimeout(() => {
      updateAllUpsellCardImages();
    }, 80);
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  window.CustomCartUpdateUpsellImages =
    updateAllUpsellCardImages;
})();